import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogPostalMailIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogPostalMail",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.51 10.21h2.28c.59 0 1.08-.48 1.08-1.08s-.48-1.08-1.08-1.08H7.51V5.76c0-.59-.49-1.08-1.08-1.08s-1.08.48-1.08 1.08v2.28H3.07c-.59 0-1.08.48-1.08 1.08s.48 1.08 1.08 1.08h2.28v2.3c0 .59.48 1.08 1.08 1.08s1.08-.48 1.08-1.08v-2.28Zm22.47 9.81q0-.135-.09-.24c-.05-.06-1.25-1.48-3.91-1.48-.52 0-.48 0-.86.07-.32.04-.29.05-.58.05h-.03v-2.46c0-1.13-.92-2.04-2.05-2.04H10.11c-1.13 0-2.05.91-2.05 2.04v6.48c0 1.14.92 2.05 2.05 2.05h2.92c-.1.17-.2.42-.16.69.08.56.57.97 1.36 1.14.66.13 8.12.91 9.07.98h.09c.84 0 2.28-.81 2.43-.9 0 0 .36-.43 1.22-.79.25-.1.52-.17.76-.26.86-.27 1.76-.54 2.02-1.64.16-.67.16-3.38.16-3.7h-.02Zm-18.56 1.95c-.1.11-.25.18-.42.18-.33 0-.59-.26-.59-.59 0-.17.08-.33.19-.44l2.07-2.02-2.03-1.83a.57.57 0 0 1-.14-.38c0-.32.27-.59.59-.59a.5.5 0 0 1 .31.1l4.13 3.66a1.175 1.175 0 0 0 1.57 0l4.12-3.66c.1-.1.24-.15.39-.15.33 0 .59.26.59.59 0 .17-.08.33-.2.44l-1.5 1.34c-.17.03-.35.05-.54.05-.72 0-1.37.24-1.77.65a1.62 1.62 0 0 0-.36 1.65c-.4.34-.94.57-1.52.57s-1.15-.23-1.57-.59l-1.18-1.05zm17.66 1.57c-.15.64-.64.82-1.5 1.08-.27.09-.54.17-.81.28-.9.36-1.23.78-1.29.81-.58.33-1.64.87-2.1.8-.9-.06-8.36-.84-8.96-.97-.34-.07-.72-.23-.75-.48-.02-.1.08-.24.16-.31s.1-.17.1-.27l8.27-.02c0 .16.1.31.26.36.2.07.42-.03.49-.24.52-1.52 1.22-2.14 1.22-2.14.1-.09.15-.21.14-.34a.42.42 0 0 0-.2-.3c-.37-.2-.7-.15-.99-.1-.14.03-.29.04-.46.04-.36 0-.71-.08-1.08-.16-.41-.1-.84-.18-1.36-.18-1.68 0-1.7-.73-1.71-.96 0-.24.07-.44.23-.59.24-.26.73-.42 1.22-.42.54 0 .97-.12 1.4-.24.38-.1.75-.21 1.22-.22.63-.02 1.1.06 1.45.12.22.03.4.07.52.07.35 0 .36 0 .7-.06.37-.06.29-.06.73-.06 1.92 0 2.95.83 3.23 1.1 0 1.18-.03 2.95-.14 3.38Z"
    })
  }));
};